import { z } from 'zod';

export const payoutPresetSchema = z.enum([
  'DAILY',
  'WEEKLY_MONDAY',
  'WEEKLY_FRIDAY',
  'BIWEEKLY',
  'MONTHLY_FIRST',
]);
export type PayoutPreset = z.infer<typeof payoutPresetSchema>;

export const payoutScheduleSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('rate'), intervalHours: z.number().int().min(1) }),
  z.object({ kind: z.literal('cron'), expression: z.string().min(1), timezone: z.string().min(1) }),
  z.object({ kind: z.literal('preset'), preset: payoutPresetSchema }),
]);
export type PayoutSchedule = z.infer<typeof payoutScheduleSchema>;
